import Vue from 'vue';

/**
 * Layer to easily control our advertisement config.
 *
 * @param context
 * @param inject
 */
export default (context, inject) => {
    inject('ads', Vue.observable({
        // Whether ads shall be displayed on the current page
        enabled: false,

        // Whether ads are allowed to be displayed according to the user settings
        allowed: false,

        // Whether the ads script is already loaded
        loaded: false,

        enable: function () {
            this.enabled = true;
            this.init();
        },

        allow: function () {
            this.allowed = true;
            this.init();
        },

        /**
         * Loads the ad script when it should already be loaded.
         */
        init: function () {
            if (this.allowed && this.enabled && !this.loaded) {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1633676878063665';
                script.crossOrigin = 'anonymous';
                script.async = true;

                document.head.appendChild(script);
                this.loaded = true;
            }
        }
    }))
}